import { useEmailHistory } from './EmailHistoryContext';

/**
 * The ✉️ chip: every email with this candidate, as one timeline.
 *
 * Deliberately just "✉️" with no count. A count would have to come from somewhere, and the only
 * place is the board payload — which this feature must not add to. The history is fetched when
 * the chip is CLICKED (no prefetch, no hover prefetch), so a board with fifty cards costs nothing.
 *
 * It depends on nothing but the candidate's id and name, so it sits next to the notes chip without
 * borrowing any of its props. Outside an EmailHistoryProvider it renders nothing.
 *
 * A plain <button>, not the DS `Button`, on purpose: it is a pill that has to sit beside the 📝
 * chip (also a plain button) and look like it, and `Button`'s own padding, height and centred
 * label are a labelled-action shape, not a 22px chip. Colours are the DS `cotton` / `iron` tokens.
 */
export function EmailChip({ candidateName, opportunityId }: { candidateName: string; opportunityId: string }) {
  const api = useEmailHistory();
  if (!api) return null;
  return (
    <button
      type="button"
      onClick={() => api.openEmails({ opportunityId, candidateName })}
      className="inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold bg-cotton text-iron hover:opacity-80"
      title="Email history with this candidate"
      aria-label={`Email history with ${candidateName}`}
    >
      ✉️
    </button>
  );
}
